import { Tooltip } from 'antd'
import { useAppDispatch } from '@/hooks'
import {
  setAnalysisImageId,
  setAnalysisWorkId,
  setSelectedPage
} from '@/features/SetAnalysisImageInfo/setAnalysisImageInfo'
import {
  setCompareImageId,
  setCompareWorkId
} from '@/features/SetCompareImageInfo/setCompareImageInfo'
import { setShowType } from '@/features/SetCompareInfo/setCompareInfo'
import { SRC_URL } from '@/server'

const DynastyOrder = (props) => {
  const dispatch = useAppDispatch()
  const chuanyiData = props.similarImgsInfo
  const chuanyiDataKeys = Object.keys(chuanyiData)
  return (
    <div className='chuanyi-dynastyOrder'>
      {chuanyiDataKeys.map((dynasty) => {
        return chuanyiData[dynasty].length > 0 ? (
          <div className='chuanyi-eachDynasty' key={dynasty}>
            <div className='chuanyi-eachDynasty-dynastyName'>{dynasty}</div>
            <div className='chuanyi-eachDynasty-divider'>
              <div className='chuanyi-eachDynasty-divider-circle'></div>
              <div className='chuanyi-eachDynasty-divider-line'></div>
            </div>
            <div className='chuanyi-eachDynasty-images'>
              {chuanyiData[dynasty].map((eachImg) => {
                return (
                  <div className='chuanyi-eachDynasty-images-eachImage' key={eachImg.imgSrc}>
                    <Tooltip
                      overlayStyle={{ maxWidth: 1920 }}
                      title={
                        <div>
                          <button
                            className='chuanyi-compareImgButton'
                            onClick={() => {
                              dispatch(setAnalysisImageId(eachImg.imageId))
                              dispatch(setAnalysisWorkId(eachImg.workId))
                            }}
                          >
                            画作分析
                          </button>
                          <button
                            className='chuanyi-compareImgButton'
                            onClick={() => {
                              dispatch(setCompareImageId(eachImg.imageId))
                              dispatch(setCompareWorkId(eachImg.workId))
                              dispatch(setSelectedPage(2))
                              dispatch(setShowType(2))
                            }}
                          >
                            画作对比
                          </button>
                        </div>
                      }
                      trigger='click'
                    >
                      <img
                        className='chuanyi-eachDynasty-images-eachImage-showImg'
                        src={eachImg.imgSrc ? SRC_URL + eachImg.imgSrc : ''}
                        alt=''
                      ></img>
                    </Tooltip>
                    <div className='chuanyi-eachDynasty-images-eachImage-imgInfo'>
                      <div className='chuanyi-eachDynasty-images-eachImage-imgInfo-title'>
                        {eachImg.title + ' ' + eachImg.similarity + '%'}
                      </div>
                      <div className='chuanyi-eachDynasty-images-eachImage-imgInfo-author'>
                        {eachImg.author}
                      </div>
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
        ) : null
      })}
    </div>
  )
}

export default DynastyOrder
